import { useNavigate } from "react-router-dom";

const CallToAction = ({ subTitle, title, image, button }: any) => {
  const navigate = useNavigate();

  return (
    <section className="newsletter__area">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-4">
            <div className="newsletter__img-wrap">
              <img
                src={
                  image?.node?.sourceUrl ??
                  "/assets/img/index/mtb-subscribe.png"
                }
                alt="img-text"
                width={296}
                height={296}
              />
              <img
                src="/assets/img/others/newsletter_shape01.png"
                alt="img-text"
                data-aos="fade-up"
                data-aos-delay="400"
                width={428}
                height={145}
              />
              <img
                src="/assets/img/others/newsletter_shape02.png"
                alt="img-text"
                className="alltuchtopdown"
                width={76}
                height={92}
              />
            </div>
          </div>
          <div className="col-lg-8">
            <div className="newsletter__content">
              <h2 className="title">
                {title ?? "Dive in the world of "}
                <br /> <span>{subTitle ?? "Media & Entertainment "}</span>{" "}
              </h2>
              <div className="newsletter__form">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (button?.url) {
                      window.location.href = button?.url;
                    } else {
                      navigate("/contact");
                    }
                  }}
                >
                  {/* <input type="email" placeholder="Type your e-mail"> */}
                  <button type="submit" className="btn">
                    {button?.title ?? "Enquire Now"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="newsletter__shape">
        <img
          src="/assets/img/others/newsletter_shape03.png"
          alt="img-text"
          data-aos="fade-left"
          data-aos-delay="400"
          width={382}
          height={320}
        />
      </div>
    </section>
  );
};

export default CallToAction;
